// Fragments don't work inside a Switch
// https://stackoverflow.com/questions/58169397/redirect-doesnt-work-inside-switch-when-fragment-has-been-used
// https://stackoverflow.com/questions/67140467/react-router-routes-not-working-using-a-fragment

import * as React from 'react';
import { Switch } from 'react-router-dom';

import { flattenChildren } from '@sbu/utils.dom';

export const FragmentSupportingSwitch = ({ children }) => {
  const flattened = flattenChildren(children);
  return <Switch>{flattened}</Switch>;
};
